// removed by extract-text-webpack-plugin
module.exports = {"pill":"CwPill-pill","closeIcon":"CwPill-closeIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwpill/CwPill.scss
// module id = 375
// module chunks = 0